export default __webpack_public_path__ + "static/media/avatar-s-11.5bb0323d.png";